import React, { Component } from 'react';


class Step11 extends Component {

    render() {
        return (
            <div className="card card-body">
                <div className="row">
                    <div className="form-group">
                        <div className="h2">C4 Individual Equipment or Device Record</div>
                    </div>
                </div>

                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 1</div>
                        <div className="col-sm-12 col-md-12">
                            <div className="form-group">
                                <input id="c4loc1" name="c4loc1" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <input id="c4dev1" name="c4dev1" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4correct1">Correctly Installed</label>
                                <select id="c4correct1" name="c4correct1" className="custom-select">
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4serv1">Requires Service</label>
                                <select id="c4serv1" name="c4serv1" className="custom-select">
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf1">Alarm Operation Confirmed</label>
                                <select id="c4conf1" name="c4conf1" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="cann1">Annunciation Confirmed</label>
                                <select id="c4ann1" name="c4ann1" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf1">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone1" name="c4circzone1" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4supfault1">Supervision/Ground Fault</label>
                                <select id="c4supfault1" name="c4supfault1" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4remarks1">Remarks</label>
                                <textarea id="c4remarks1" name="c4remarks1" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>
                {/* device 2 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 2</div>
                        <div className="col-sm-12 col-md-12">
                            <div className="form-group">
                                <input id="c4loc2" name="c4loc2" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <input id="c4dev2" name="c4dev2" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4correct2">Correctly Installed</label>
                                <select id="c4correct2" name="c4correct2" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4serv2">Requires Service</label>
                                <select id="c4serv2" name="c4serv2" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf2">Alarm Operation Confirmed</label>
                                <select id="c4conf2" name="c4conf2" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="cann2">Annunciation Confirmed</label>
                                <select id="c4ann2" name="c4ann2" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf2">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone2" name="c4circzone2" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4supfault2">Supervision/Ground Fault</label>
                                <select id="c4supfault2" name="c4supfault2" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf2">Remarks</label>
                                <textarea id="c4remarks2" name="c4remarks2" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>
                {/* device 3 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 3</div>

                        <div className="col-sm-12 col-md-12">
                            <div className="form-group">
                                <input id="c4loc3" name="c4loc3" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <input id="c4dev3" name="c4dev3" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4correct3">Correctly Installed</label>
                                <select id="c4correct3" name="c4correct3" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4serv3">Requires Service</label>
                                <select id="c4serv3" name="c4serv3" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf3">Alarm Operation Confirmed</label>
                                <select id="c4conf3" name="c4conf3" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="cann3">Annunciation Confirmed</label>
                                <select id="c4ann3" name="c4ann3" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf3">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone3" name="c4circzone3" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4supfault3">Supervision/Ground Fault</label>
                                <select id="c4supfault3" name="c4supfault3" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf3">Remarks</label>
                                <textarea id="c4remarks3" name="c4remarks3" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>
                {/* device 4 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 4</div>
                        <div className="col-sm-12 col-md-12">
                            <div className="form-group">
                                <input id="c4loc4" name="c4loc4" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <input id="c4dev4" name="c4dev4" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4correct4">Correctly Installed</label>
                                <select id="c4correct4" name="c4correct4" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4serv4">Requires Service</label>
                                <select id="c4serv4" name="c4serv4" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf4">Alarm Operation Confirmed</label>
                                <select id="c4conf4" name="c4conf4" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="cann4">Annunciation Confirmed</label>
                                <select id="c4ann4" name="c4ann4" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf4">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone4" name="c4circzone4" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4supfault4">Supervision/Ground Fault</label>
                                <select id="c4supfault4" name="c4supfault4" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                                <label htmlFor="c4conf4">Remarks</label>
                                <textarea id="c4remarks4" name="c4remarks4" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>

            </div>
        );
    }
};

export default Step11;



// WEBPACK FOOTER //
// ./src/components/Step11.js